var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_vm._v(" "),_c('body',[_c('v-app',[_c('router-view')],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('head',[_c('link',{attrs:{"href":"https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Material+Icons","rel":"stylesheet"}}),_vm._v(" "),_c('link',{attrs:{"href":"https://use.fontawesome.com/releases/v5.9.0/css/all.css","rel":"stylesheet"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb6e484e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/App.vue
// module id = 29
// module chunks = 0